import { Pipe, PipeTransform } from '@angular/core';
import { ConverterStatusEnum } from '@zaoblako/shared/modules/pacs/enums/converter-status.enum';

const converterStatusColors: Record<ConverterStatusEnum, string> = {
  [ConverterStatusEnum.NOT_CONNECTED]: '#808080',
  [ConverterStatusEnum.OFFLINE]: '#d92626',
  [ConverterStatusEnum.ONLINE]: '#5e9a3b'
};

@Pipe({
  name: 'converterStatusColor',
  standalone: true
})
export class ConverterStatusColorPipe implements PipeTransform {
  public transform(status: ConverterStatusEnum): string {
    return converterStatusColors[status] || '';
  }
}
